// @flow
import { type Node, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import putOnFoodErrorProcessing from './putOnFoodErrorProcessing';


type Props = {
  children: ({
    header: string,
    successMessage: string,
    errorProcessing: (Error) => string,
  }) => Node,
  whom: string,
  whomAccusative: string,
}

const PutOnFood = ({ children, whom, whomAccusative }: Props): Node => {
  const { t } = useTranslation('cafeteria');

  const header = t('order_request_sales_put_on_food_header', { whom });
  const successMessage = t('order_request_sales_put_on_food_success_message', { whom });

  const errorProcessing = useMemo(() => (
    putOnFoodErrorProcessing(whomAccusative)
  ), [whomAccusative]);

  return (
    children({
      header,
      successMessage,
      errorProcessing,
    })
  );
};

export default PutOnFood;
